module.exports = __webpack_public_path__ + "static/img/print.aa731d63.svg";